<template>
  <div class="multi-select-input">
    <div class="edit" v-if="!readOnly" >
      <multi-select-component :mode="multipleOrSingle" v-model="internalValue" :options="valueOptions" :configurationOptions="{'allow-empty': false, 'label-inside':false, showMulipleValues:true}"/>
    </div>
    <span v-else class="value">{{value.join(', ')}}</span>
  </div>
</template>

<script>
import inputMixin from '@/mixins/inputMixin'

import MultiSelectComponent from '@/components/MultiSelectComponent'

export default {
  name: 'MultiSelectInput',
  mixins: [inputMixin],
  components: {MultiSelectComponent},
  computed:{
    multipleOrSingle () {
      let t = 'single'
      if(this.view.inputType === 'checkboxes'){
        t = 'multiple'
      } 
      if(this.view.inputType === 'select' && this.view.validate_max > 1){
        t = 'multiple'
      } 
      return t
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>